import { render } from "./productView.vue?vue&type=template&id=75cd6972&scoped=true"
import script from "./productView.vue?vue&type=script&lang=js"
export * from "./productView.vue?vue&type=script&lang=js"

import "./productView.vue?vue&type=style&index=0&id=75cd6972&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cd6972"]])

export default __exports__